<section>
  <div class="form-register">
    <form [formGroup]="formDevolutionProjectionDetail">
      <div class="row p-1">
        <div class="col-lg-3 col-md-4 col-sm-6 col-12">
          <app-custom-input-text [disabled]="true" [labelText]="'Artículo'" [value]="codeNameArticle" [required]="true">
          </app-custom-input-text>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-6 col-12">
          <app-custom-input-text [disabled]="true" [labelText]="'Bodega'" [value]="codeNameStore" [required]="true">
          </app-custom-input-text>
        </div>
        <div class="col-lg-1 col-md-4 col-sm-6 col-12">
          <app-custom-input-decimal [labelText]="'Existencia'" formControlName="stock" [required]="true">
          </app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="quantity" [labelText]="'Cantidad'" [required]="true"
            (onChangeNumber)="validateQuantity($event)"></app-custom-input-decimal>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-12 col-12 d-flex mt-2">
          <div class="d-flex align-items-end gap-1">
            <app-custom-button [label]="'Guardar'" [severity]="'primary'" (onClick)="send()"></app-custom-button>
            <app-custom-button [label]="'Cancelar'" [severity]="'danger'" (onClick)="clearForm()">
            </app-custom-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>